var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWasteBinTidyman(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 321,
    viewBox: "0 0 214 321",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.164 295.647C181.25 309.377 172.874 320.611 163.551 320.611H49.3831C40.0599 320.611 31.6839 309.377 30.7705 295.647L12.7586 24.9924C11.8452 11.2635 18.7265 0.0292969 28.0496 0.0292969H184.885C194.208 0.0292969 201.09 11.2624 200.176 24.9924L182.164 295.647Z",
    fill: "#505050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.037 56.3198V290H181.89L195.5 56.3198H107.037Z",
    fill: "#404040"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.953 0.0302734C204.416 0.0302734 212.898 12.5813 212.898 28.0622C212.898 43.5441 204.415 56.0941 193.953 56.0941H18.9812C8.5189 56.0952 0.0366211 43.5452 0.0366211 28.0622C0.0366211 12.5813 8.5189 0.0302734 18.9812 0.0302734H193.953Z",
    fill: "#505050"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M202.584 0.319824C208.357 0.319824 213.037 12.8565 213.037 28.3198C213.037 43.7841 208.357 56.3198 202.584 56.3198H106.037C106.037 38.2765 106.037 28.7874 106.037 28.7874C106.037 13.3241 106.037 17.3004 106.037 0.319824H202.584Z",
    fill: "#4B4B4B"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.301 159.89H107.057",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.475 160.286L99.5392 222.894H70.2198L58.864 160.286",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1797 222.894L94.3955 159.89H82.4858L84.5037 222.894H78.1334L70.3386 159.89M60.9612 171.381H104.288L103.496 181.684H62.7417L64.6014 191.986H102.388L101.518 202.289H66.5401L68.3602 212.591H100.331L60.9612 171.381Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.896 119.274L141.085 119.433C146.625 125.614 155.725 146.417 156.121 151.569L124.467 153.154C123.676 142.455 118.928 132.905 118.136 131.4L77.896 119.274ZM124.467 155.135L113.784 224.479L138.316 178.91L149.394 224.875L155.725 155.927L124.467 155.135Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M128.424 117.887C134.979 117.887 140.294 112.565 140.294 106C140.294 99.4348 134.979 94.1118 128.424 94.1118C121.868 94.1118 116.553 99.4348 116.553 106C116.553 112.565 121.868 117.887 128.424 117.887Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7488 148.399C76.5902 142.851 76.5111 134.53 77.3815 134.53C87.669 138.889 97.5608 140.077 103.892 138.492C85.4533 152.757 94.7911 153.154 92.2588 152.361C84.4641 149.587 73.1478 157.909 65.7488 148.399ZM85.0971 137.304C95.1868 137.304 95.1868 134.134 97.1652 133.222C97.1652 133.222 98.3522 137.304 100.727 139.285",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWasteBinTidyman);
export default __webpack_public_path__ + "static/media/waste-bin-tidyman.0ed408e9c9394e7bbce2b4e7d81702f1.svg";
export { ForwardRef as ReactComponent };